import { ref } from 'vue';
import { Loading } from 'quasar';
import type { StrapiProviders } from 'src/shared/composables/useStrapiApi';
import { useStrapiGet } from 'src/shared/composables/useStrapiApi';

// Fetched once per app load: provider settings only change in the Strapi admin.
const enabledProviders = ref<StrapiProviders[]>([]);
let loaded: Promise<void> | null = null;

/**
 * Google/Facebook sign-in shared by the parent and school login pages.
 *
 * Buttons show only for providers enabled in Strapi. The OAuth round-trip
 * returns to the origin it started from (`?callback=`), so each brand gets its
 * own user back; the backend allowlists both frontends. The landing route
 * (`users.connect`) finishes the sign-in in `boot/auth.ts`.
 */
export function useProviderSignIn() {
  if (!loaded) {
    loaded = useStrapiGet(
      'users-permissions/auth/providers',
      {},
      { suppressError: true },
    )
      .execute()
      .then(({ data }) => {
        enabledProviders.value = Array.isArray(data) ? data : [];
      });
  }

  function isEnabled(provider: StrapiProviders) {
    return enabledProviders.value.includes(provider);
  }

  function providerSignIn(provider: StrapiProviders) {
    Loading.show();
    const callback = `${window.location.origin}/users/connect/${provider}/redirect`;
    window.location.href = `${import.meta.env.VITE_BACKEND_API_URL}/connect/${provider}?callback=${encodeURIComponent(callback)}`;
  }

  return { enabledProviders, isEnabled, providerSignIn };
}
